import React, { Component } from 'react'
// import { Row, Col } from 'antd'
import moment from 'moment'

export default class Description extends Component {
  render () {
    const { dateTime } = this.props
    function toDay (time) {
      return moment(time).format('DD')
    }
    function toMonth (time) {
      return moment(time).format('MMMM')
    }
    return (
      <div style={{ paddingTop: '2em' }}>
        <div className="eventDateBox">
          <div className="dateBoxText">
            {`${toDay(dateTime)}  ${toMonth(dateTime)}`}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/EventPage/Components/Description.js